import { Product } from "./Product.model";

export class OrderLine {
    product?: Product;  
    quantity: number=1;
    realPurchasePrice?: number;
    realSellingPrice?: number;
    returnedQuantity?: number;
    constructor(product: Product, quantity: number, realPurchasePrice: number, realSalePrice: number, returnedQuantity?: number) {
        this.product = product;
        this.quantity = quantity;
        this.realPurchasePrice = realPurchasePrice;
        this.realSellingPrice = realSalePrice;
        this.returnedQuantity = returnedQuantity;
    }
    

}